import { useContext } from 'react'

import {
  Button, Columns, LoadingModule, SaveFormModule,
} from '@domain-group/suit-theme'

import useTrainingLesson, { useTrainingLessonForm } from '@hooks/useTrainingLesson'

import PageContext from '@contexts/pageContext'

import PageLayout from '../../../../components/PageLayout'
import TrainingLessonTools from '../../../../components/TrainingLessonTools'

import TrainingLessonDetails from '../TrainingLessonDetails'
import TrainingLessonMedia from '../TrainingLessonMedia'

const PageContent = (props: { trainingLessonId: number}) => {
  const { trainingLessonId } = props

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      updateTrainingLesson,
    },
  } = pageContext

  const trainingLessonPayload = useTrainingLesson({ id: trainingLessonId })
  const {
    callbacks: {
      updateTrainingLesson: updateFn,
    },
    loaded,
    loading,
    trainingLesson,
    updating,
    urls,
  } = trainingLessonPayload

  const trainingLessonFormPayload = useTrainingLessonForm(trainingLesson, { validateOn: 'change' })
  const { entityState, saveEnabled } = trainingLessonFormPayload

  const updateTrainingLessonPayload = {
    callbacks: {
      action: updateFn,
    },
    entityParams: entityState,
    toastText: 'Training Lesson Updated',
  }

  return (
    <PageLayout entityPayload={trainingLessonPayload} activeTabBarItemKey="details">
      <Columns.Main>
        <LoadingModule loading={loading && !loaded} times={3} />

        {(!loading || loaded) && (
          <>
            <TrainingLessonDetails
              trainingLessonFormPayload={trainingLessonFormPayload}
              urls={urls}
            />

            <SaveFormModule>
              <Button
                buttonStyle="primaryCreate"
                disabled={!saveEnabled}
                loading={updating}
                // @ts-expect-error TS2322
                marginLeft="auto"
                onClick={() => updateTrainingLesson(updateTrainingLessonPayload)}
                size="medium"
              >
                Save Details
              </Button>
            </SaveFormModule>
          </>
        )}
      </Columns.Main>

      <Columns.Sidebar>
        <TrainingLessonMedia trainingLessonPayload={trainingLessonPayload} />

        <TrainingLessonTools trainingLessonPayload={trainingLessonPayload} />
      </Columns.Sidebar>
    </PageLayout>
  )
}

export default PageContent
